import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { contactUsDataasDataTable, contactUs, contactUsPublic } from './thunks';
import { ContactUsState } from './types';

export const name = 'contactUs';

const initialState: ContactUsState = {
  data: null,
  status: 'idle',
};

export const contactUsDataasDataTableAsync = createAsyncThunk(
  name + '/contactUsDataasDataTable',
  contactUsDataasDataTable
);

export const contactUsAsync = createAsyncThunk(name + '/contactUs', contactUs);

export const contactUsPublicAsync = createAsyncThunk(
  name + '/contactUsPublic',
  contactUsPublic
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(contactUsDataasDataTableAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(contactUsDataasDataTableAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(contactUsDataasDataTableAsync.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(contactUsAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(contactUsAsync.fulfilled, (state) => {
        state.status = 'success';
      })
      .addCase(contactUsAsync.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(contactUsPublicAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(contactUsPublicAsync.fulfilled, (state) => {
        state.status = 'success';
      })
      .addCase(contactUsPublicAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
